import { mediaRequest, uploadMediaTo } from "./projectMediaClient.js";

const path = id => `/api/markets/${encodeURIComponent(id)}/media`;
const EVENT = "places:market-media-changed";
export async function getMarketMedia(id) {
  const result = await mediaRequest(path(id));
  if (!Array.isArray(result?.items) || typeof result?.capabilities?.canManage !== "boolean" || !Object.hasOwn(result, "effectiveCover")) {
    throw new Error("The server returned an invalid market media list.");
  }
  return result;
}
export const uploadMarketMedia = (id, file, _week, progress, signal) => uploadMediaTo(path(id), file, null, progress, signal);
export const updateMarketMedia = (id, mediaId, caption) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}`, {
  method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ caption }),
});
export const removeMarketMedia = (id, mediaId) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}`, {
  method: "DELETE", headers: { "Content-Type": "application/json" }, body: JSON.stringify({}),
});
export const restoreMarketMedia = (id, mediaId, undoToken) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}/restore`, {
  method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ undoToken }),
});
export const reorderMarketMedia = (id, ids) => mediaRequest(`${path(id)}/order`, {
  method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ids }),
});
export const setMarketCover = (id, mediaId) => mediaRequest(`${path(id)}/cover`, {
  method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ mediaId: mediaId ?? null }),
});
export function emitMarketMediaChanged(id, source = null, result) {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(EVENT, { detail: { marketId: String(id), source, result } }));
}
export function onMarketMediaChanged(id, handler) {
  if (typeof window === "undefined") return () => {};
  const listener = e => { if (e.detail?.marketId === String(id)) handler(e.detail); };
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
export const marketMediaAdapter = Object.freeze({
  entityType: "market", list: getMarketMedia, upload: uploadMarketMedia,
  update: updateMarketMedia, remove: removeMarketMedia, setCover: setMarketCover, restore: restoreMarketMedia, reorder: reorderMarketMedia,
  emit: emitMarketMediaChanged, subscribe: onMarketMediaChanged,
});
